import _defineProperty from "@babel/runtime/helpers/defineProperty";
/**
 * API Client
 * Wrapper around @wix/http-client with error handling and type safety
 */

import { HttpClient } from '@wix/http-client';
import { toApiError } from './error';
export class ApiClient {
  constructor(config) {
    _defineProperty(this, "httpClient", void 0);
    const timeout = config.timeout ?? 30000;
    this.httpClient = new HttpClient({
      baseURL: config.baseURL,
      timeout,
      createHeaders: () => ({
        'x-time-budget': `${timeout}`,
        ...config.headers
      })
    });
  }

  /**
   * GET request with error handling
   */
  async get(url, config) {
    try {
      const response = await this.httpClient.get(url, config);
      return response.data;
    } catch (error) {
      throw toApiError(error);
    }
  }

  /**
   * POST request with error handling
   */
  async post(url, data, config) {
    try {
      const response = await this.httpClient.post(url, data, config);
      return response.data;
    } catch (error) {
      throw toApiError(error);
    }
  }

  /**
   * PATCH request with error handling
   */
  async patch(url, data, config) {
    try {
      const response = await this.httpClient.patch(url, data, config);
      return response.data;
    } catch (error) {
      throw toApiError(error);
    }
  }

  /**
   * PUT request with error handling
   */
  async put(url, data, config) {
    try {
      const response = await this.httpClient.put(url, data, config);
      return response.data;
    } catch (error) {
      throw toApiError(error);
    }
  }

  /**
   * DELETE request with error handling
   */
  async delete(url, config) {
    try {
      const response = await this.httpClient.delete(url, config);
      return response.data;
    } catch (error) {
      throw toApiError(error);
    }
  }
}

// Apps must create their own instance with app-specific config:
// export const apiClient = new ApiClient({ baseURL: '/api', timeout: 30000 });
//# sourceMappingURL=client.js.map